// Zenklub services.
import { HttpClient } from '@angular/common/http';
// Angular modules.
import { Injectable } from '@angular/core';
import { ICountry, IRegion } from 'app/interfaces/location.interface';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// Zenklub interfaces.
import {
	EthnicityResponse,
	IEthnicity,
	ILanguage,
	LanguagesResponse,
} from '../interfaces/search.interface';

@Injectable()
export class SearchService {
	// Constructor.
	constructor(private http: HttpClient) {}

	// Get ethnicity list.
	public getEthnicityList(): Observable<IEthnicity[]> {
		const url = `search/ethnicities`;
		return this.http
			.get<EthnicityResponse>(url)
			.pipe(map((res) => res.ethnicities));
	}

	// Get languages list.
	public getLanguages(): Observable<ILanguage[]> {
		const url = `search/languages?limit=500`;
		return this.http
			.get<LanguagesResponse>(url)
			.pipe(map((res) => res.languages));
	}

	public getCountryRegions(countryId?: ICountry['id']): Observable<IRegion[]> {
		return this.http.get<IRegion[]>(
			`search/regions/${countryId ? `?countryId=${countryId}` : ''}`
		);
	}
}
